import { buildModelManager } from "../builder.js";
const DefaultApprenticeConversationSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  deletedAt: true,
  lastActiveAt: true,
  profileId: true,
  title: true,
  updatedAt: true
};
const modelApiIdentifier = "apprenticeConversation";
const pluralModelApiIdentifier = "apprenticeConversations";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultApprenticeConversationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultApprenticeConversationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeConversationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeConversationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeConversationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeConversationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultApprenticeConversationSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "apprenticeConversationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ApprenticeConversationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultApprenticeConversationSelection,
  operations
);
export {
  ApprenticeConversationManager,
  DefaultApprenticeConversationSelection
};
//# sourceMappingURL=ApprenticeConversation.js.map
